module.exports = __webpack_public_path__ + "static/media/screenshot1.105234b6.png";